import { useTranslation } from 'react-i18next';
import { NAV } from './nav';
import { homeRoute } from './permissions';
import { useAuth } from './auth';
import Flow from '../screens/Flow';

/**
 * The landing route: the process flow, which is the same picture of the department for everybody. It needs no
 * permission of its own — each stage carries one, and a stage the reader cannot open comes back without its figure.
 *
 * It replaced a redirect to /dash/stores, which needs rpt.dashboard.stores.view: eight of the thirteen seeded roles do
 * not hold it, so signing in used to land them on a permission-denied page. A person with no permissions at all is
 * told so plainly rather than shown an empty diagram.
 */
export default function Home() {
  const { t } = useTranslation();
  const permissions = useAuth((s) => s.user?.permissions);
  const hasSomething = homeRoute(NAV, (code) => permissions?.includes(code) ?? false) !== '/no-access';

  if (hasSomething) return <Flow />;
  return (
    <div className="card-gap">
      <h1>{t('home.noAccess.title')}</h1>
      <p className="muted">{t('home.noAccess.body')}</p>
    </div>
  );
}
